<template>
    <div class="withdrawalamount">
        <ul>
            <li>
                <span class="text">实际提取金额</span>
                <span class="money_box">
                    <span class="money_icon">￥</span>
                    <span class="amount">{{withdrawDetailInfo.actualAmount}}</span>
                </span>
            </li>
            <li>
                <span class="text">可提现积分金额</span>
                <span class="money_box">
                    <span class="money_icon">￥</span>
                    <span class="amount">{{withdrawDetailInfo.amount}}</span>
                </span>
            </li>
            <li>
                <span class="text">补税金额</span>
                <span class="money_box">
                    <span class="money_icon">￥</span>
                    <span class="amount">{{withdrawDetailInfo.tax}}</span>
                </span>
            </li>
            <li class="flex_clounm">
                <p class="text">结算规则</p>
                <p class="rule">*实际提现金额=提现金额+补税金额</p>
                <p class="rule">*提示：请提供符合要求的增值税发票：税点=6%</p>
                <p class="rule">*价税合计金额=实际提现金额</p>
            </li>
        </ul>
    </div>
</template>
<script>
import api from "@/utils/api";
export default {
    data() {
        return {
           
        }
    },
    created() {
        // this.fetchPolicyList();
    },
    computed:{
        withdrawDetailInfo () {
            return this.$store.state.withdrawDetailInfo
        }
    },
    methods:{
       
    }
}
</script>
<style lang="scss" scoped>
    .withdrawalamount {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #999999;
        padding: 15px 20px;
        box-sizing: border-box;
        text-align: left;
        ul {
            width: 100%;
            background: #f9f9f9;
            border-radius: 7px;
            padding: 24px 15px;
            box-sizing: border-box;
            li {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 5.5px;
                .text {
                    font-size: 13px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: #333333;
                    line-height: 18.5px;
                }
                .money_box {
                    color: #FF7C6D;
                    .money_icon {
                        font-size: 9px;
                        font-family: HelveticaNeue-Bold, HelveticaNeue;
                        font-weight: bold;
                    }
                    .amount {
                        font-size: 16px;
                        font-family: HelveticaNeue-Bold, HelveticaNeue;
                        font-weight: bold;
                        color: #FF7C6D;
                        line-height: 19px;
                    }
                }
            }
            li.flex_clounm {
                flex-direction: column;
                align-items: flex-start;
                .text {
                    margin-bottom: 7px;
                }
                .rule {
                    font-size: 12px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    color: #999999;
                    line-height: 16.5px;
                    margin-bottom: 5.5px;
                }
                .rule:last-child {
                    margin-bottom: 0;
                }
            }
        }
    }
</style>